(function () {
  const FORM_SELECTOR = 'mc-form, teddy-auth-login, teddy-auth-register, teddy-auth-profile, teddy-auth-reset';
  const FIELD_SELECTOR = 'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])';
  const BOUND_ATTR = 'data-rns-scroll-bound';

  function scrollToFirstInvalid(formEl) {
    if (!formEl || !formEl.querySelector) return;
    const host = formEl.querySelector('.is-invalid');
    if (!host) return;
    const field = host.querySelector(FIELD_SELECTOR);
    if (field) field.focus({ preventScroll: true });
    host.scrollIntoView({ block: 'center', behavior: 'auto' });
  }

  function onValidate(e) {
    if (!e || !e.detail || e.detail.valid !== false) return;
    scrollToFirstInvalid(e.currentTarget);
  }

  function bind(formEl) {
    if (!formEl || formEl.hasAttribute(BOUND_ATTR)) return;
    formEl.setAttribute(BOUND_ATTR, '');
    formEl.addEventListener('mc:form:validate', onValidate);
  }

  function attachAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(FORM_SELECTOR).forEach(bind);
    if (root && root.matches && root.matches(FORM_SELECTOR)) bind(root);
  }

  function init() {
    attachAll(document);
    const observer = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) attachAll(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
